import { CardBrand, CardFunding, FinancialTransactionType } from 'shared/types/graphql';
import { PaymentReportColumnNames, PaymentReportColumnSelectors } from '../enums';
import { IColumnSelection } from '../types';

export const initialTransactionsColumnsSelection: IColumnSelection[] = [
  {
    name: PaymentReportColumnNames.ClientName,
    selector: PaymentReportColumnSelectors.ClientName,
    sortable: true,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.Conversation,
    selector: PaymentReportColumnSelectors.Conversation,
    sortable: false,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.TransactionType,
    selector: PaymentReportColumnSelectors.TransactionType,
    sortable: true,
    omit: false,
    width: '180px',
  },
  {
    name: PaymentReportColumnNames.PaymentStatus,
    selector: PaymentReportColumnSelectors.PaymentStatus,
    sortable: true,
    omit: false,
    width: '175px',
  },
  {
    name: PaymentReportColumnNames.Date,
    selector: PaymentReportColumnSelectors.Date,
    sortable: true,
    omit: false,
    width: '155px',
  },
  {
    name: PaymentReportColumnNames.Disbursed,
    selector: PaymentReportColumnSelectors.Disbursed,
    sortable: true,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.Amount,
    selector: PaymentReportColumnSelectors.Amount,
    sortable: true,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.ClientFee,
    selector: PaymentReportColumnSelectors.ClientFee,
    sortable: true,
    omit: false,
    width: '115px',
  },
  {
    name: PaymentReportColumnNames.TotalInvoiced,
    selector: PaymentReportColumnSelectors.TotalInvoiced,
    sortable: true,
    omit: false,

    width: '165px',
  },
  {
    name: PaymentReportColumnNames.TransactionFees,
    selector: PaymentReportColumnSelectors.TransactionFees,
    sortable: true,
    omit: false,
    width: '165px',
  },
  {
    name: PaymentReportColumnNames.NetProceeds,
    selector: PaymentReportColumnSelectors.NetProceeds,
    sortable: true,
    omit: false,
    width: '145px',
  },
  {
    name: PaymentReportColumnNames.SentBy,
    selector: PaymentReportColumnSelectors.SentBy,
    sortable: true,
    omit: false,
    width: '145px',
  },
  {
    name: PaymentReportColumnNames.PaymentMethod,
    selector: PaymentReportColumnSelectors.PaymentMethod,
    sortable: false,
    omit: false,
    width: '165px',
  },
  {
    name: PaymentReportColumnNames.Terminal,
    selector: PaymentReportColumnSelectors.Terminal,
    sortable: true,
    omit: false,
    width: '165px',
  },
  {
    name: PaymentReportColumnNames.CardBrand,
    selector: PaymentReportColumnSelectors.CardBrand,
    sortable: true,
    omit: false,
    width: '145px',
  },
  {
    name: PaymentReportColumnNames.CardType,
    selector: PaymentReportColumnSelectors.CardType,
    sortable: true,
    omit: false,
    width: '145px',
  },
  {
    name: PaymentReportColumnNames.Last4,
    selector: PaymentReportColumnSelectors.Last4,
    sortable: true,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.Actions,
    selector: PaymentReportColumnSelectors.Actions,
    sortable: false,
    omit: false,
  },
];

export interface PaymentReportStripePaymentIntent {
  id: string;
  amount: number;
  amountCaptured: number;
  clientServiceFee: number;
  paidAt: Date;
  paymentIdentifier?: string | null;
  status?: string | null;
  stripePaymentMethod: {
    cardBrand?: CardBrand | null;
    last4?: string | null;
    funding?: CardFunding | null;
  };
  refundedAmount: number;
  stripeReceiptId?: string | null;
}

export const transactionTypeMap: Record<FinancialTransactionType, string> = {
  [FinancialTransactionType.Adjustment]: 'Adjustment',
  [FinancialTransactionType.DirectBookingDeposit]: 'Direct Booking Deposit',
  [FinancialTransactionType.Dispute]: 'Dispute',
  [FinancialTransactionType.Refund]: 'Refund',
  [FinancialTransactionType.SubscriptionRefund]: 'Refund',
  [FinancialTransactionType.Sale]: 'Payment',
  [FinancialTransactionType.Subscription]: 'Subscription',
  [FinancialTransactionType.SubscriptionRefund]: 'Subscription Refund',
};
